module.exports = __webpack_public_path__ + "static/media/R.Suite.21cbfc6e.png";